import React from 'react';

import ShimmerComponent from '../../../shimmerComponent/shimmerComponent';
import ShimmerEmptyImageTextComponent from './shimmerEmptyImageTextComponent';
import EmptyAgenda from '../../../../../assets/svgComponents/EmptyAgenda';

import './overviewAgendaShimmerComponent.css';

const OverviewAgendaShimmerComponent = ({showShimmer = true}) => {
  return (
    <>
      {showShimmer ? (
        <>
          {Array.from({length: 3}).map((val, idx) => (
            <div key={idx} className="et-v2-overview-agenda-shimmer-wrap">
              <ShimmerComponent />
            </div>
          ))}
        </>
      ) : (
        <div className="et-v2-overview-agenda-empty-shimmer-wrap">
          <ShimmerEmptyImageTextComponent
            ImageComponent={EmptyAgenda}
            titleTxt="Your agenda is empty"
            subTitleTxt="You currently have no upcoming meetings"
          />
        </div>
      )}
    </>
  );
};

export default OverviewAgendaShimmerComponent;
